export const tiktokProfileURLRegExp =
  /^https:\/\/(?:[a-z]{2,3}\.)?tiktok\.com\/@([^\s/@?#]+)/;
export const tiktokHashtagURLRegExp =
  /^https:\/\/(?:[a-z]{2,3}\.)?tiktok\.com\/tag\/([^\s/?#]+)/;
